import { ResolveFn } from '@angular/router';
import {GarfieldReport} from '../../models/reports/garfield-report';

/**
 * Resolve report based on report kind and route context
 *
 * @param route
 * @param state
 */
export const garfieldFinancialReportResolver: ResolveFn<GarfieldReport | undefined> = (route, state) => {
	return GarfieldReport.fromRoute(route);
};
